import { Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { handleUnauthorizedResponse } from '../../../api/http';
import InvoiceApi from '../../../api/InvoiceApi';
import { AuthData } from '../../../context/auth';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import FutureInvoices from '../../FutureInvoicesTable';
import { errorToast } from '../../Toast';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
}

const useStyles = makeStyles((theme: Theme) => ({
	titleWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-end',
		marginTop: theme.spacing(1.25), // 10px
	},
	title: {
		fontSize: '18px',
		textTransform: 'capitalize',
		lineHeight: 'inherit',
	},
	sectionContainer: {
		marginTop: theme.spacing(2.5), // 20px
	},
}));

const FutureInvoicesView = (props: Props) => {
	const classes = useStyles();

	const { authData, policyData } = props;

	const { policy, selectedQuote } = policyData;

	const [invoices, setInvoices] = useState([]);

	useEffect(() => {
		// TODO: use hook useFutureAndGeneratedInvoices
		const fetchFutureInvoices = async () => {
			try {
				const invoicesResponse =
					await InvoiceApi.fetchFutureAndGeneratedInvoices(
						authData.auth.authorizationToken,
						policy.locator,
					);
				setInvoices(invoicesResponse.data.futureInvoices);
			} catch (error) {
				if (await handleUnauthorizedResponse(error, authData)) {
					return;
				}
				errorToast('Failed to fetch future invoices');
			}
		};
		// if we are viewing future invoices for a quote, use the quote object
		if (!policy.issuedTimestamp && selectedQuote) {
			setInvoices(selectedQuote.invoices);
		} else {
			fetchFutureInvoices();
		}
	}, [authData, policy.locator, selectedQuote]);

	return (
		<>
			<Box className={classes.titleWrapper}>
				<Typography className={classes.title}>Future Invoices</Typography>
			</Box>
			<hr />
			<Box className={classes.sectionContainer}>
				<FutureInvoices invoices={invoices} currency={policy?.currency} />
			</Box>
		</>
	);
};

export default withPolicyContext<Props>(FutureInvoicesView);
